import Accordion from 'ui3/Accordion/Accordion';
// Types
import { MerchType } from 'api/graphql-global-types';
// Helpers
import { getMerchDetails, getMerchShippingDetails } from 'helpers/merch';
// Components
import TrustBadges from 'components/common3/EcommerceTrustBadges/TrustBadges/TrustBadges';
// Styles
import styles from './DetailsAndPolicies.module.scss';

type DetailsAndPoliciesProps = {
  productType?: MerchType | null | undefined;
  isYouth?: boolean;
  openedByDefault?: boolean;
  showShipping?: boolean;
  showMemorabilia?: boolean;
};

const DetailsAndPolicies: React.FC<DetailsAndPoliciesProps> = ({
  productType,
  isYouth = false,
  openedByDefault = false,
  showShipping = false,
  showMemorabilia = false,
}) => {
  const typeList = productType
    ? getMerchDetails(productType, isYouth)
    : getMerchShippingDetails(showShipping);

  const title = productType
    ? 'Product Details'
    : showShipping
    ? 'Shipping and Return Policies'
    : 'Return Policies';

  const isShippingSection = !productType;

  return (
    <Accordion
      title={title}
      className={styles.root}
      openedByDefault={openedByDefault}
      titleClassName={styles.title}
      isWhiteIcon
      headingLevel="h2"
    >
      <ul className={styles.list}>
        {typeList.map((item) => (
          <li key={item} className={styles.listItem}>
            <p className={styles.text}>{item}</p>
          </li>
        ))}
      </ul>
      {isShippingSection && (
        <TrustBadges
          showShipping={showShipping}
          showMemorabilia={showMemorabilia}
          iconsOnly
          className={styles.trustBadges}
        />
      )}
    </Accordion>
  );
};

export default DetailsAndPolicies;
